module.exports = __webpack_public_path__ + "static/media/instagram.5c7abd21.svg";